import * as actionTypes from "../constants/actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {
    me: null,
    registeringAs: null,
    authToken: null,
    impersonatingContactId: null,    
};

function ACCOUNT_STORE(state, action) {
    const { me } = action;
    return {
        ...state,
        me,
    }
}

function ACCOUNT_IMPERSONATING_CONTACT_ID_STORE(state, action)
{
    const { impersonatingContactId } = action;    
    return {
        ...state,
        impersonatingContactId,
    }
}

function ACCOUNT_AUTH_TOKEN_STORE(state, action) {
    const { authToken } = action;    
    return {
        ...state,
        authToken,
    }
}

function ACCOUNT_REGISTERING_AS_STORE(state, action) {
    const { registeringAs } = action;
    return {
        ...state,
        registeringAs,
    }
}

function ACCOUNT_CLEAR(state, action) {
    return defaultState;
}

const handlers = {};
handlers[actionTypes.ACCOUNT_STORE] = ACCOUNT_STORE;
handlers[actionTypes.ACCOUNT_CLEAR] = ACCOUNT_CLEAR;
handlers[actionTypes.ACCOUNT_REGISTERING_AS_STORE] = ACCOUNT_REGISTERING_AS_STORE;
handlers[actionTypes.ACCOUNT_AUTH_TOKEN_STORE] = ACCOUNT_AUTH_TOKEN_STORE;
handlers[actionTypes.ACCOUNT_IMPERSONATING_CONTACT_ID_STORE] = ACCOUNT_IMPERSONATING_CONTACT_ID_STORE;
export default createReducer(defaultState, handlers);